export const customerMaterialUrl = "/customer-material";
